// Footer.js
import React from "react";

function Footer() {
  return (
    <footer
      style={{
        background: "linear-gradient(135deg, #ff66cc, #9933ff)",
        color: "#ffffff",
        padding: "1rem 0",
      }}
    >
      <div className="container d-flex flex-column flex-md-row align-items-center justify-content-between">
        {/* Left section: Logo + Copyright */}
        <div className="d-flex align-items-center mb-2 mb-md-0">
        </div>

        {/* Right section: "Contact Us" button */}
        <button
          className="btn btn-outline-light btn-sm"
          style={{ borderRadius: "20px" }}
          onClick={() => alert("Contact us - no link yet!")}
        >
          Contact Us
        </button>
      </div>
    </footer>
  );
}

export default Footer;
